import axios from "axios"
import { getApiBaseUrl } from "../common/utils"

const API = axios.create({
  baseURL: getApiBaseUrl(),
  headers: { "Content-type": "application/json" }
})

const API_FORM = axios.create({
  baseURL: getApiBaseUrl(),
  headers: { "Content-Type": "multipart/form-data" }
})

const API_PUBLIC = axios.create({
  baseURL: getApiBaseUrl(),
  headers: { "Content-type": "application/json" }
})

export { API, API_FORM, API_PUBLIC }
export default API
